// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__l5GdD","title":"FrontImage_title__69pR2"};